
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"action.label":"In CSV-Datei exportieren","dialog.title":"Datenerstellung (CSV)"},"en":{"action.label":"Export to CSV file","dialog.title":"Generating Data (CSV)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();